export type ValidationError = Record<string, unknown> | null | undefined;

export function hasValidationErrors<T extends ValidationError | ValidationError[]>(
  validationResult: T
): boolean {
  if (Array.isArray(validationResult)) {
    return validationResult.some(v => v && Object.keys(v).length > 0);
  }
  if (validationResult && typeof validationResult === 'object') {
    return Object.keys(validationResult).length > 0;
  }
  return false;
}

export function validateRows<RowType, ValidationResultType>(
  rows: RowType[],
  validateAll: (rows: RowType[]) => ValidationResultType
) {
  const res = validateAll(rows);
  const hasErrors = hasValidationErrors(res as unknown as ValidationError | ValidationError[]);
  return { ok: !hasErrors, errors: res };
}

export default {
  hasValidationErrors,
  validateRows
};